export default __webpack_public_path__ + "static/media/logo-white.ed9f833b.svg";